<template>
  <div
    :id="id"
    class="rs-inline-form-toolbar"
  >
    <div class="row m-0 h-100 align-items-center">
      <slot>
        <div class="toolbar-left flex-grow-1">
          <slot name="toolbarPrepend" />
          <slot name="toolbarLeft">
            <RsButton
              v-show="hasEdit"
              class="btn-toolbar-inline"
              @click="handleEditClicked()"
            >
              <i class="far fa-pencil" />
            </RsButton>
            <RsButton
              v-show="hasDuplicate"
              class="btn-toolbar-inline"
              @click="handleDuplicateClicked()"
            >
              <i class="far fa-clone" />
            </RsButton>
            <RsButton
              v-show="hasRemove"
              class="btn-toolbar-inline"
              @click="handleRemoveClicked()"
            >
              <i class="far fa-trash" />
            </RsButton>
          </slot>
        </div>

        <div class="toolbar-right flex-grow-1 text-right">
          <slot name="toolbarRight">
            <RsButton
              v-show="hasCancel"
              variant="cancel"
              @click="handleCancelClicked()"
            >
              {{ $ts('actions.cancel') }}
            </RsButton>
            <RsButton
              v-show="hasSave"
              variant="secondary"
              @click="handleSaveClicked()"
            >
              {{ $ts('actions.save') }}
            </RsButton>
          </slot>
        </div>
      </slot>
    </div>
  </div>
</template>

<script lang="ts">
import { defineComponent } from 'vue';

const eventsMap: Record<string, string> = {
  onSaveClicked: 'on-save-clicked',
  onCancelClicked: 'on-cancel-clicked',
  onEditClicked: 'on-edit-clicked',
  onRemoveClicked: 'on-remove-clicked',
  onDuplicateClicked: 'on-duplicate-clicked',
};

export default defineComponent({
  name: 'RsInlineFormToolbar',

  props: {
    id: {
      type: String,
      required: true,
    },

    disabled: {
      type: Boolean,
      default: false,
    },

    hasDuplicate: {
      type: Boolean,
      default: true,
    },

    hasEdit: {
      type: Boolean,
      default: true,
    },

    hasRemove: {
      type: Boolean,
      default: true,
    },

    hasCancel: {
      type: Boolean,
      default: false,
    },

    hasSave: {
      type: Boolean,
      default: true,
    },

    logEventHandlers: {
      type: Boolean,
      default: false,
    },
  },

  mounted() {
    if (this.logEventHandlers) {
      // eslint-disable-next-line no-console
      console.log('Available Events', Array.from(Object.keys(eventsMap), (key) => `@${eventsMap[key]}`));
    }
  },

  methods: {
    handleEditClicked() {
      this.$emit(eventsMap.onEditClicked);
    },

    handleDuplicateClicked() {
      this.$emit(eventsMap.onDuplicateClicked);
    },

    handleRemoveClicked() {
      this.$emit(eventsMap.onRemoveClicked);
    },

    handleSaveClicked() {
      this.$emit(eventsMap.onSaveClicked);
    },

    handleCancelClicked() {
      this.$emit(eventsMap.onCancelClicked);
    },
  },
});
</script>

<style lang="scss">
@import '@/styles/_variables.scss';
$toolbar-container-bg: #F5F6Fb;

.rs-inline-form-toolbar {
  background: $toolbar-container-bg;
  border: solid 1px $border-color;
  height: 48px;
  padding: 0 20px 0 20px;

  .toolbar-height {
    height: 48px;
  }

  .rs-collapse-lite {
    border: 0 !important;

    .card-header {
      .btn {
        background: $toolbar-container-bg !important;
        padding: 0 0 0 0 !important;
        font-size: 14px !important;
        color: $tertiary-dark !important;
        font-weight: normal !important;
      }
    }

    .card-body {
      border-top: 0 !important;
    }
  }

  /* Handle nested cases */
  .rs-inline-form {
    margin: 0 -21px 0 -21px;
    transition: none;
  }

  button {
    height: 32px;
    padding: 4px 10px;
  }

  .toolbar-right {
    button {
      margin-right: .25rem;
      padding: 4px 16px;
    }
  }
}
</style>
